import React from "react";
import Button from "./Button";

const Hero = () => {
  const handleScheduleClick = () => {
    // Open Calendly popup immediately without loading state
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/brad-wilde/eluno-consulting-introductory-call",
      });
    } else {
      console.error("Calendly widget failed to load");
    }
  };

  return (
    <div className="relative overflow-hidden bg-dark">
      {/* Background image with overlay */}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-r from-dark via-dark/95 to-dark/90"></div>
        <div
          className="absolute inset-0 bg-center bg-cover"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1483478550801-ceba5fe50e8e?ixlib=rb-1.2.1&auto=format&fit=crop&w=1650&q=80')",
            backgroundBlendMode: "overlay",
            opacity: 0.2,
          }}
        ></div>
      </div>

      {/* Additional subtle gradient overlays for depth */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        <div className="absolute -top-20 -right-20 w-72 h-72 bg-accent/10 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/3 w-96 h-96 bg-accent/5 rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24 lg:pt-40 lg:pb-32">
        <div className="text-center lg:text-left">
          <div className="flex flex-col items-center lg:items-start">
            <div className="w-full max-w-3xl">
              <h1 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-light leading-tight">
                Accelerate Your
                <span className="text-accent block md:inline">
                  {" "}
                  Digital & Strategic{" "}
                </span>
                Initiatives
              </h1>
              <p className="mt-6 text-xl text-light/90 max-w-2xl mx-auto lg:mx-0">
                Expert consulting tailored to your business needs without the
                overhead.
              </p>
              <div className="mt-10 flex flex-col sm:flex-row justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-4">
                <Button
                  primary
                  onClick={handleScheduleClick}
                  className="min-w-[240px]"
                >
                  Schedule Your Free Call
                </Button>
                <Button onClick={() => (window.location.href = "/services")}>
                  Learn More
                </Button>
              </div>
            </div>

            {/* Decorative element for visual interest */}
            <div className="hidden lg:block absolute right-8 top-1/2 transform -translate-y-1/2 opacity-70">
              <div className="relative">
                <div className="absolute top-0 -left-4 w-72 h-72 bg-accent/30 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse"></div>
                <div
                  className="absolute -top-10 -right-4 w-72 h-72 bg-accent/20 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse"
                  style={{ animationDelay: "1s" }}
                ></div>
                <div
                  className="absolute -bottom-8 left-20 w-72 h-72 bg-accent/40 rounded-full mix-blend-multiply filter blur-3xl opacity-70 animate-pulse"
                  style={{ animationDelay: "2s" }}
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Responsive design enhancement - bottom gradient for mobile */}
      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-dark to-transparent z-5"></div>
    </div>
  );
};

export default Hero;
